const RESUME_HREF = '/resume/2019-05/ace-quisido-resume.pdf';

export default RESUME_HREF;
